// The agents' marks (design/assets/Agents, the same files as the Apple apps). Masks follow the ink colour in light and
// dark; colour marks keep their own. UI only: Node's test runner cannot import images.
import claudeCode from '../../../design/assets/Agents/claude-code.png';
import codex from '../../../design/assets/Agents/codex.png';
import cursor from '../../../design/assets/Agents/cursor.png';
import geminiCli from '../../../design/assets/Agents/gemini-cli.png';
import githubCopilot from '../../../design/assets/Agents/github-copilot.png';

export interface AgentLogo {
  url: string;
  mask: boolean;
}

export const AGENT_LOGOS: Readonly<Record<string, AgentLogo>> = {
  'claude-code': { url: claudeCode, mask: false },
  codex: { url: codex, mask: true },
  cursor: { url: cursor, mask: true },
  'gemini-cli': { url: geminiCli, mask: false },
  'github-copilot': { url: githubCopilot, mask: true },
};
